// extracted by mini-css-extract-plugin
export default {"root":"StripeElementsForPaymentMethodUpdate_root__IhVqz","divider":"StripeElementsForPaymentMethodUpdate_divider__6M2W5"};